// Whop pixel standard events for the storefront. Wires around her-part-tracking.js
// (which installs the pixel + page view when marketing consent allows).
// Purchases are Whop-processed and reported to Meta by Whop; never fire "purchase".
(() => {
  const PRICES = { ss: 39, ot: 79, kit: 99 };
  function sid() {
    const m = document.cookie.match(/(?:^|; )hp_sid=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : Math.random().toString(36).slice(2);
  }
  function whenPixel(fn, tries = 0) {
    if (window.whop && typeof window.whop.track === "function") return fn(window.whop);
    if (tries < 40) setTimeout(() => whenPixel(fn, tries + 1), 250);
  }
  if (/^\/products\//.test(location.pathname)) {
    whenPixel((w) => w.track("view_content", {
      event_id: `hp:${sid()}:view_content:${location.pathname}`,
    }));
  }
  document.addEventListener("click", (event) => {
    const link = event.target.closest?.("a[href]");
    if (!link) return;
    let dest;
    try { dest = new URL(link.href); } catch { return; }
    const plan = dest.pathname.slice(1);
    if (dest.hostname !== "secure.getherpart.com" || !(plan in PRICES)) return;
    if (!window.whop || typeof window.whop.track !== "function") return;
    window.whop.track("add_to_cart", {
      event_id: `hp:${sid()}:add_to_cart_click:${plan}:${Date.now()}`,
      value: PRICES[plan], currency: "USD",
    });
  }, true);
})();
